import { Button } from '@predoc/cow';

export const Footer = () => {
  return (
    <footer className="text-muted-foreground flex w-full items-center justify-center space-x-4 py-[10px] text-center text-sm">
      <span>© {new Date().getFullYear()} Predoc. All rights reserved.</span>
      <Button
        variant="link"
        className="text-muted-foreground p-0 underline"
        asChild
      >
        <a
          href="mailto:info@memrhealth.com,support@memrhealth.com?subject=Support Request"
          target="_blank"
          rel="noopener noreferrer"
        >
          Contact Us
        </a>
      </Button>
      <Button
        variant="link"
        className="text-muted-foreground p-0 underline"
        asChild
      >
        <a
          href="https://cdn.prod.website-files.com/6827c1994862c627993a82d8/689b1d65a78dcb11fd4ec394_privacy-policy.pdf"
          target="_blank"
          rel="noopener noreferrer"
        >
          Privacy Policy & Terms of Use
        </a>
      </Button>
    </footer>
  );
};
